var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-layout',{staticClass:"white"},[_c('v-card',{attrs:{"flat":true}},[_c('v-card-text',{staticClass:"text-xs-center py-5"},[(!_vm.error)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_c('v-alert',{attrs:{"value":true,"type":"error"}},[_vm._v("\n        "+_vm._s(_vm.error)+"\n      ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }